var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstRecipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9297 120.719V122.141H30.8359V129.359H29.1016V115.266H30.8359V120.719H32.9297ZM20.2734 125.875V116.641H21.9922V124.438C23.875 124.406 25.875 124.242 28.0078 123.797L28.1953 125.266C25.8125 125.742 23.5547 125.867 21.4609 125.875H20.2734ZM40.7734 116.484V123.156H34.0859V116.484H40.7734ZM35.6953 129.109V124.578H37.4297V127.703H45.3047V129.109H35.6953ZM35.7891 121.781H39.0703V117.875H35.7891V121.781ZM43.0078 125.578V115.266H44.7422V119.406H46.7109V120.859H44.7422V125.578H43.0078ZM52.0078 116.25C54.25 116.242 55.8828 117.656 55.8984 119.656C55.8828 121.664 54.25 123.07 52.0078 123.078C49.7891 123.07 48.125 121.664 48.1328 119.656C48.125 117.656 49.7891 116.242 52.0078 116.25ZM47.4922 125.031C50.0391 125.031 53.5625 125 56.6172 124.562L56.7578 125.828C53.5938 126.43 50.2031 126.453 47.7109 126.453L47.4922 125.031ZM49.8516 119.656C49.8438 120.836 50.7734 121.562 52.0078 121.562C53.2578 121.562 54.1875 120.836 54.1953 119.656C54.1875 118.484 53.2656 117.75 52.0078 117.75C50.7734 117.75 49.8438 118.484 49.8516 119.656ZM57.4609 129.406V115.266H59.1953V129.406H57.4609ZM70.1328 118.328C70.125 119.883 71.2734 121.422 73.4922 122.031L72.6953 123.375C71.0859 122.93 69.9297 121.969 69.2969 120.758C68.6797 122.133 67.5156 123.219 65.8516 123.75L65.0078 122.375C67.2344 121.695 68.3984 120.047 68.3984 118.328V118.188H65.4453V116.812H68.3984V115.219H70.1484V116.812H73.0859V118.188H70.1328V118.328ZM66.7109 127.953C69.4844 127.523 71.2969 125.906 71.3047 124.328V124.062H73.1016V124.328C73.0859 125.984 74.8516 127.555 77.7109 127.953L77.0234 129.312C74.7656 128.969 73.0391 127.914 72.1875 126.461C71.3203 127.891 69.5859 128.977 67.3359 129.312L66.7109 127.953ZM72.6797 120.531V119.109H75.1484V115.266H76.8828V124.953H75.1484V120.531H72.6797ZM88.1172 116.734V121.922H84.7734V124.57C86.2266 124.555 87.6094 124.492 89.2109 124.203L89.3516 125.625C87.4531 125.977 85.8594 126.008 84.0859 126.016H83.1016V120.547H86.4453V118.125H83.0859V116.734H88.1172ZM88.7422 121.594V120.172H90.2891V115.562H91.9297V128.672H90.2891V121.594H88.7422ZM93.1797 129.391V115.266H94.8359V129.391H93.1797ZM101.852 118.656C101.836 121.25 103.203 123.844 105.492 124.828L104.461 126.219C102.836 125.469 101.648 123.977 100.992 122.133C100.344 124.117 99.125 125.742 97.4141 126.547L96.3516 125.094C98.7031 124.078 100.078 121.383 100.086 118.656V116.406H101.852V118.656ZM106.508 129.406V115.266H108.258V129.406H106.508ZM122.133 115.266V129.391H120.383V115.266H122.133ZM110.305 124.625C110.852 124.625 111.438 124.617 112.055 124.609V118.062H110.68V116.641H118.695V118.062H117.336V124.398C118.008 124.344 118.68 124.281 119.32 124.203L119.414 125.5C116.383 125.992 113.078 126.047 110.477 126.047L110.305 124.625ZM113.727 124.578C114.352 124.562 114.992 124.539 115.633 124.5V118.062H113.727V124.578Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 49.0005C119.019 75.5258 97.5238 97.0205 70.9985 97.0205C44.4732 97.0205 22.9785 75.5258 22.9785 49.0005C22.9785 22.4751 44.4732 0.980469 70.9985 0.980469C97.5238 0.980469 119.019 22.4751 119.019 49.0005Z",
    fill: "url(#paint0_linear_1275_5271)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1758 71.343H50.0612C49.5712 71.343 49.1465 70.951 49.1465 70.4283C49.1465 69.9057 49.5385 69.5137 50.0612 69.5137H90.1758C90.6658 69.5137 91.0905 69.9057 91.0905 70.4283C91.0905 70.951 90.6985 71.343 90.1758 71.343Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0371 29.9874L86.8758 24.8261C85.7978 23.7481 84.0664 23.7481 83.0211 24.8261L79.7871 28.0601L81.0611 29.3341L87.4964 35.7694L88.7704 37.0434L92.0044 33.8094C93.1151 32.7967 93.1151 31.0654 92.0371 29.9874Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2563 37.0765L79.821 30.6412L78.547 29.3672L53.3936 54.5205L53.361 54.5532C53.2956 54.6185 53.263 54.6839 53.1976 54.7819C53.1976 54.8145 53.165 54.8145 53.165 54.8472C53.165 54.8472 53.165 54.8799 53.1323 54.8799L49.2776 66.4765C49.1796 66.8032 49.245 67.1625 49.5063 67.4239C49.6696 67.5872 49.931 67.6852 50.1596 67.6852C50.2576 67.6852 50.3556 67.6525 50.4536 67.6525L62.0503 63.7979C62.083 63.7979 62.083 63.7652 62.083 63.7652C62.1156 63.7652 62.1156 63.7325 62.1483 63.7325C62.2463 63.6999 62.3116 63.6345 62.377 63.5692L62.4096 63.5365L87.563 38.3832L86.2563 37.0765ZM54.243 64.3859L52.479 62.6219L54.4063 56.8072L60.0576 62.4585L54.243 64.3859Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5271)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9999,
    cy: 48.9999,
    r: 42.4906,
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5271",
    x: 49.1465,
    y: 24.0176,
    width: 43.6953,
    height: 48.3514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5271",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5271",
    x1: 37.6785,
    y1: 11.4338,
    x2: 107.749,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstRecipe);
export default __webpack_public_path__ + "static/media/FirstRecipe.e06a1ac3f023b543276304a741a5b7e0.svg";
export { ForwardRef as ReactComponent };